import React from 'react';

import language from '../../../../../assets/languages/language';

function ChapterWiseGraph({ graphData, activeTabFlashcards, flashcardTabToggle }) {
  return (
    <div className=' chart-graph-wrapper'>
      <h1 className='overAllScore'>{`${language.LC().CFACHAPTERWISERESULT}`}</h1>
      <div id='chartContainer' className='js-chart-wrap' />
      <ul className='legend-wrapper'>
        <li>
          <span className='square-box' /> {language.LC().SCOREBOX}
        </li>
        <li>
          <span className='line-dash' /> {language.LC().Percentile_20}
        </li>
        <li>
          <span className='line-dots' /> {language.LC().Percentile_80}
        </li>
        <li>
          <span className='line-normal' />
          {language.LC().YOURSCORE}
        </li>
      </ul>
      <h1 className='mt-5'>Mean Score by Topic Area</h1>
      <div className='d-flex header-card-dashboard tab-header-wrap mt-2'>
        <ul className='dashboard-card-header-tab'>
          {graphData
            ? graphData.map((exam, index) => {
                return (
                  <li
                    onClick={() => {
                      flashcardTabToggle(index + 1);
                    }}
                    className={activeTabFlashcards === index + 1 ? 'active' : ''}
                  >
                    <span
                    // className={graphData.length > 6 ? 'font-size-8' : ''}
                    >
                      {exam.chapterDetails['esg_chapter.name'] &&
                      exam.chapterDetails['esg_chapter.name'].length > 8
                        ? `${exam.chapterDetails['esg_chapter.name'].substring(0, 8)}..`
                        : exam.chapterDetails['esg_chapter.name']}
                    </span>
                  </li>
                );
              })
            : null}
        </ul>
      </div>

      {graphData
        ? graphData.map((exam, index) => {
            let x;

            x =
              activeTabFlashcards === index + 1 ? (
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      <div className=' graphData'>
                        <div className='graphScoreData'>
                          <div className='graphScore'>{`${
                            exam.dataOfTwentyPercentileUser
                              ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage)
                              : 0
                          }%`}</div>
                          <div className='graphLabel'>
                            <span className='percentileTwentyScore-box' />{' '}
                            {language.LC().Percentile_20}
                          </div>
                        </div>
                        <div className='graphScoreData'>
                          <div className='graphScore'>{`${
                            exam.dataOfEightyPercentileUser
                              ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage)
                              : 0
                          }%`}</div>
                          <div className='graphLabel'>
                            <span className='percentileEightyScore-box' />{' '}
                            {language.LC().Percentile_80}
                          </div>
                        </div>
                        <div className='graphScoreData'>
                          <div className='graphScore'>{`${
                            exam.dataOfCurrentUser
                              ? Math.ceil(exam.dataOfCurrentUser.Percentage)
                              : 0
                          }%`}</div>
                          <div className='graphLabel'>
                            <span className='score-box' /> {`${language.LC().YOURSCORE}`}
                          </div>
                        </div>
                        <div className='graphScoreData'>
                          <div className='graphScore'>{`${
                            exam && exam.chapterDetails && exam.chapterDetails.totalQuestions
                              ? Math.ceil(
                                  (exam.averageScore / exam.chapterDetails.totalQuestions) * 100,
                                )
                              : 0
                          }%`}</div>
                          <div className='graphLabel'>
                            <span className='average-box' /> {language.LC().AVERAGE_SCORE}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null;

            return x;
          })
        : null}

      <div className='pt-2 text-center'>
        <p>{language.LC().DataDetail}</p>
      </div>
    </div>
  );
}

export default ChapterWiseGraph;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ResultGraph/ChapterWiseGraph/ChapterWiseGraph.jsx